import appData from '../config/App_data';
import GetData from '../RestAPI/getDataService';

const retrieveVideos = async data => {
  return await GetData.callAPI(`${appData.backend_api}/exams/cfa/videos/all-videos`, data);
};
const retrieveLastViewedVideo = async (data = {}) => {
  return await GetData.callAPI(`${appData.backend_api}/exams/cfa/videos/last-video-viewed`, {...data,});
};
module.exports = {
  retrieveVideos,
  retrieveLastViewedVideo,
};



// WEBPACK FOOTER //
// ./src/views/Videos/ApiService.js